import type { ReactNode } from 'react';
import { PlatformRequireRole } from '@jarvis/platform-ui';
import type { OpsRole } from './roles';
import { useHasRole } from './useHasRole';

interface RequireRoleProps {
  role: OpsRole;
  children: ReactNode;
}

/** Gates nested routes when the signed-in user lacks the required Ops App Role (SPA-side UX guard). */
export function RequireRole({ role, children }: RequireRoleProps) {
  const { hasOpsRole } = useHasRole();
  return (
    <PlatformRequireRole role={role} hasRole={hasOpsRole} roleLabel="Ops App Role">
      {children}
    </PlatformRequireRole>
  );
}
